import { Mui } from "@osu/react-ui";
import React, { useState } from "react";
import { connect } from 'react-redux';
import { NOTES_STATES_CASES } from "../../NotesState";

const mapStateToProps = (state) => { return { notes: state?.studentData?.student?.data?.restrictions ?? [] }; }

const errorColorSx = (theme) => ({
  color: theme.palette?.colors?.red || theme.palette?.error?.main || '#d32f2f',
  fontWeight: 'bold',
});

function RestrictionsNotes(props) {
    const { notes } = props;
    const { noteDispatch } = props;
    const notesOptions = getNestedParentChildNotesOptions(notes);

    const [selectedValue, setSelectedValue] = useState('');

    const handleRadioChange = (event) => {
        const label = event.target.value;
        setSelectedValue(label);

        // Build state matching the existing noteDispatch contract
        const newState = {};
        notes.forEach(note => { newState[note.label] = note.label === label ? { value: true, hasChildren: false } : false; });
        updateParentNotesStateForSubmission(noteDispatch, newState);
    };

    return (
        <>
            <Mui.Typography color="secondary">Restrictions:<Mui.Box component="span" sx={errorColorSx}>*</Mui.Box></Mui.Typography>
            <Mui.RadioGroup value={selectedValue} onChange={handleRadioChange}>
                {notesOptions.map((notesOption) => (
                    <Mui.FormControlLabel
                        key={notesOption.label}
                        value={notesOption.label}
                        label={<Mui.Typography color="secondary">{notesOption.label}</Mui.Typography>}
                        control={<Mui.Radio inputProps={{ "aria-label": notesOption.label }} />}
                    />
                ))}
            </Mui.RadioGroup>
            {notesOptions.length === 0 && <strong><i style={{ color: "red" }}>Selectable Restrictions Notes Configuration is Missing!</i></strong>}
        </>
    );
}

function getNestedParentChildNotesOptions(notes = []) {
    return notes?.filter?.(note => !note.parentLabel) ?? [];
}

function updateParentNotesStateForSubmission(noteDispatch, state) {
    const payload = { state };
    const type = NOTES_STATES_CASES.SET_RESTRICTIONS;
    noteDispatch({ type, payload });
}

export default connect(mapStateToProps, null)(RestrictionsNotes);
